import axios from 'axios';
import { ExceptionManager } from 'Core/logManager';

export const uploadFile = async (signedUrl, fileKey) => {
	try {
		return await axios.put(signedUrl, fileKey, {
			headers: { 'Content-Type': fileKey?.type || 'application/octet-stream' }
		}).then((res) => {
			return new Promise((resolve) => {
				resolve(res.data);
			});
		})
			.catch((error) => {
				return new Promise((resolve, reject) => {
					reject(error);
				});
			});

	} catch (exc) {
		ExceptionManager(exc, 'Core/data/FileUpload', 'uploadFile');
		throw exc;
	}
};